import { render, staticRenderFns } from "./ArticleReplyViewPopup.vue?vue&type=template&id=4791d8bc&scoped=true&"
import script from "./ArticleReplyViewPopup.vue?vue&type=script&lang=ts&"
export * from "./ArticleReplyViewPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleReplyViewPopup.vue?vue&type=style&index=0&id=4791d8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4791d8bc",
  null
  
)

export default component.exports